import React, {useEffect, useState} from 'react';

const SearchJobRequireContent = (props) => {
    const [searchInput, setSearchInput] = useState({});

    const {onChange, advanceSearchInput} = props

    const onChangeRequirementInfo = (fieldName, value) => {
        searchInput[fieldName] = value
        setSearchInput({...searchInput})
        if (onChange) {
            onChange(searchInput)
        }
    };

    useEffect(() => {
        setSearchInput(advanceSearchInput)
    }, [advanceSearchInput])

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Yêu cầu</h3>
            </div>
            <div className='card-body'>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Yêu cầu đối với UV (to send)</label>
                    <div style={{width: '100%'}}>
                        <textarea className='form-control'
                                  value={searchInput.required_extracted ?
                                      searchInput.required_extracted : ''}
                                  name={'required_extracted'}
                                  onChange={event => onChangeRequirementInfo("required_extracted", event.target.value)}/>
                    </div>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Yêu cầu với UV (for user nội bộ)</label>
                    <div style={{width: '100%'}}>
                        <textarea className='form-control'
                                  value={searchInput.required_candidate_to_send ?
                                      searchInput.required_candidate_to_send : ''}
                                  name={'required_candidate_to_send'}
                                  onChange={event => onChangeRequirementInfo("required_candidate_to_send", event.target.value)}/>
                    </div>
                </div>

                <div className='input-group mt-3'>
                    <label className={'w-100'}>JD</label>
                    <input type='text' className='form-control'
                           value={searchInput["jd_content"] ? searchInput["jd_content"] : ''}
                           name={"jd_content"}
                           onChange={event => onChangeRequirementInfo("jd_content", event.target.value)}/>
                </div>
            </div>
        </div>
    )
}

export default SearchJobRequireContent;
